import { gql } from '@apollo/client';

export const saveAndSubmitHealthQuestionnaireForAdmin = gql`
mutation SaveAndSubmitHealthQuestionnaireForAdmin($id: String!, $input: SaveHealthQuestionnaireAnswersInput!, $adminId: String!) {
    saveAndSubmitHealthQuestionnaireForAdmin(id: $id, input: $input, adminId: $adminId) {
      rejected
      messages
      needsConfirmation
    }
  }
`;